import { toast } from "react-toastify";

import { persianArabicToEnglish } from "../Utils/UnicodeConvert";
import { uuidv4 } from "../Utils/Helpers";
import { axios } from "./CommonActions";
import Api from "../Constants/Api";

export function getBusinessDetail(businessId) {
  return new Promise(function (resolve, reject) {
    if (!businessId) {
      reject("business id needed");
    }
    axios({
      url: "business/" + businessId,
      method: "GET",
      _addToken: false,
    })
      .then((res) => {
        if (
          res.data.hasOwnProperty("data") &&
          res.data.data.hasOwnProperty("business_details")
        ) {
          return resolve(res?.data?.data?.business_details);
        }
        reject(false);
      })
      .catch((err) => {
        reject(false);
      });
  });
}

export function getTransactionResult(transactionId) {
  return new Promise(function (resolve, reject) {
    if (!transactionId) {
      reject("business id needed");
    }
    axios({
      url: "club/transaction/gateway/details/" + transactionId,
      method: "GET",
    })
      .then((res) => {
        // console.log("res", res?.data?.data)
        if (res.data.hasOwnProperty("data")) {
          return resolve(res?.data?.data[0]);
        }
        reject(false);
      })
      .catch((err) => {
        // console.log("err", err)
        reject(err.response);
      });
  });
}

export function setLogIn(phoneNumber) {
  return new Promise(function (resolve, reject) {
    axios({
      url: "otp/sms/send",
      method: "POST",
      _addToken: false,
      data: {
        mobile: persianArabicToEnglish(phoneNumber),
      },
    })
      .then((res) => {
        toast(res.data.message, { type: "success" });
        resolve(true);
      })
      .catch((err) => {
        reject(err);
        toast(err.response.data.message, { type: "warning" });
      });
  });
}

export function setOtp(params) {
  const clientId = uuidv4();
  return new Promise(function (resolve, reject) {
    if (typeof params.code === "string" && params.code.toString().length < 6) {
      toast("کد را وارد کنید", { type: "warning" });
      return reject("otp needed");
    }
    axios({
      url: "otp/check/login",
      method: "POST",
      _addToken: false,
      data: {
        mobile: persianArabicToEnglish(params.phoneNumber),
        code: persianArabicToEnglish(params.code),
        client_id: clientId,
        fcm_token: null,
        user_agent: "web",
      },
    })
      .then((res) => {
        if (res?.data?.data?.access_token) {
          toast("ورود با موفقیت انجام شد", { type: "success" });
          sessionStorage.setItem("Access_Token", res?.data?.data?.access_token);
          resolve(true);
        }
      })
      .catch((err) => {
        toast(err?.response?.data?.message, { type: "error" });
        reject(err.response);
      });
  });
}

export function getCredit() {
  return new Promise(function (resolve, reject) {
    axios({
      method: "GET",
      url: "wallet/credit",
    })
      .then((res) => {
        const { data } = res;
        if (
          data &&
          data.hasOwnProperty("data") &&
          data.data.hasOwnProperty("credit")
        ) {
          const { credit } = data?.data ?? {};
          resolve(credit);
        }
      })
      .catch((err) => {
        toast(err?.response?.data?.message, { type: "error" });
        reject(err.response);
      });
  });
}

export function getPaymentOptions(business_id, sub_category_id) {
  return new Promise(function (resolve, reject) {
    axios({
      method: "GET",
      baseURL: Api.PUBLIC_API_V2,
      url: "daap/wallet/payment/options",
      params: {
        business_id: business_id,
        sub_category_id: sub_category_id,
      },
    })
      .then((res) => {
        const data = res?.data?.data;
        // put an id to all objects for deleting and pushing into array (selectedPaymentOptions in paymentData)
        for (let i = 0; i < data.length; i++) {
          data[i].id = i + 1;
        }
        let newData = data;
        newData = newData.filter((item) => item.has_payment_reward === 1);
        const response = {
          paymentOptions: data,
          selectedPaymentOptions: newData,
        };
        resolve(response);
      })
      .catch((e) => {
        reject(false);
      });
  });
}

export function paymentWithPaymentCode(params) {
  return new Promise(function (resolve, reject) {
    const data = {
      payment_code: params.paymentCode,
    };
    if (params.hasOwnProperty("amount")) {
      Object.assign(params, { amount: params.amount });
    }
    axios({
      baseURL: Api.AGENCY_API,
      method: "GET",
      url: "club/customer/validateqr/dynamic",
      params: data,
    })
      .then((res) => {
        const transaction_id = res?.data?.data?.transaction_id;
        if (typeof transaction_id === "string" && transaction_id.length !== 0) {
          const data = {
            business_detail: res?.data?.data.business_detail,
            transaction_id: res?.data?.data.transaction_id,
            payment_code: res?.data?.data.payment_code,
          };
          resolve(data);
        } else {
          reject(false);
        }
      })
      .catch((err) => {
        toast(err?.response?.data?.message, { type: "error" });
        reject(err.response);
      });
  });
}

export function paymentWithTransactionId(params) {
  return new Promise(function (resolve, reject) {
    const data = {
      transaction_id: params.transaction_id,
      club_id: params.club_id,
      type: "gateway",
    };
    if (params.hasOwnProperty("amount")) {
      Object.assign(data, { amount: params.amount });
    }
    if (params.hasOwnProperty("payment_using_wallet_balance")) {
      Object.assign(data, {
        payment_using_wallet_balance: params.payment_using_wallet_balance,
      });
    }
    if (
      params.hasOwnProperty("ewallets") &&
      Array.isArray(params.ewallets) &&
      params.ewallets.length > 0
    ) {
      Object.assign(data, { ewallets: JSON.stringify(params.ewallets) });
    }
    axios({
      method: "POST",
      baseURL: Api.PUBLIC_API_V2,
      url: "daap/wallets/payment",
      data: data,
    })
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data.status &&
          Math.floor(parseInt(res.data.status) / 100) !== 2
        ) {
          const data = {
            status: "failed",
            title: "پرداخت ناموفق",
            body: res?.data?.message,
          };
          reject(data);
        } else {
          if (
            res.data.data.hasOwnProperty("redirect_url") &&
            res.data.data.redirect_url.length > 0
          ) {
            const link = res.data.data.redirect_url;
            window.location.href = link;
          } else {
            const data = {
              title: "پرداخت با موفقیت انجام شد",
              body: "",
              status: "success",
              transactionId: res.data.data.transaction_id,
            };
            resolve(data);
          }
        }
      })
      .catch((err) => {
        const data = {
          status: "failed",
          title: "پرداخت ناموفق",
          body: err?.response?.data?.message,
        };
        reject(data);
      });
  });
}

export function checkValidToken() {
  return new Promise(function (resolve, reject) {
    const accessToken = sessionStorage.getItem("Access_Token");
    axios({
      method: "POST",
      url: "token/refresh",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json; charset=utf-8",
      },
    })
      .then((res) => {
        resolve(true);
      })
      .catch((err) => {
        reject(err);
        toast("به حساب کاربری خود وارد شوید", { type: "warning" });
      });
  });
}
